// see https://immerjs.github.io/immer/installation/
import {enableES5, enableMapSet} from 'immer';
enableES5();
enableMapSet();

import configureStore from '~/configureStore';

const store = configureStore();
export default store;
